if (typeof window.$ === "undefined") {
  if (jQuery) {
    window.$ = jQuery;
  }
}

jQuery(document).ready(function () {
  $.ajax({
    url: "/wp-json/data/stats",
    type: "GET",
    success: function (data) {
      if (data) {
        // Each data from the response has a ID of the same key
        $.each(data, function (key, value) {
          // Update the text of the element with the ID of the key
          if (key === "StatsStatisticsAsOf") {
            $(`#${key}`).text(value);
          } else {
            let dataValue = value
              .toString()
              .replace(/[^0-9\.]/g, "")
              .trim();
            let dataUnit = value
              .toString()
              .replace(/[0-9\.]/g, "")
              .trim();
            //$(`#${key} .elementor-icon-box-title span`).text(value);
            $(`#${key} .elementor-icon-box-title span`).text(0);
            $(`#${key} .elementor-icon-box-title span`).addClass("counter-num");
            $(`#${key} .elementor-icon-box-title span`).attr("num", dataValue);
            $(`#${key} .elementor-icon-box-title`).append(
              "<span>" + dataUnit + "</span>"
            );
          }
        });
        //find for static values
        const dataCounters = jQuery(".stats-container .use-counter");
        dataCounters.each(function () {
          const titleSection = jQuery(this).find(".elementor-icon-box-title");
          const dataUnit = jQuery(this).attr("data-unit");
          const dataValue = jQuery(this).attr("data-value");
          const titleSpan = titleSection.find("span");
          titleSpan.addClass("counter-num");
          titleSpan.text(0);
          titleSpan.attr("num", dataValue);
          titleSection.append("<span>" + dataUnit + "</span>");
        });
        counterElementsObserver();
      }
    },
  });

  if ($(".pdmp-contact-form").length) {
    $("#form-field-fname").attr("maxlength", 50);
    $("#form-field-flastname").attr("maxlength", 50);
    $("#form-field-email").attr("maxlength", 80);
    $("#form-field-message").attr("maxlength", 250);
  }
});

jQuery(window).on("load", function () {
  let isMobile = window.matchMedia(
    "only screen and (max-width: 768px)"
  ).matches;
  if (isMobile && $(".collapsed-accordion-mobile").length) {
    $(".collapsed-accordion-mobile .e-n-accordion-item[open]").removeAttr(
      "open"
    );
  }
});

function counterElementsObserver() {
  // Elements
  const counterElements = document.querySelectorAll(
    ".pdmp-benefits-impact-box .counter-num"
  );
  const applyEffect = (entries, observer) => {
    entries.forEach((entry) => {
      const { target } = entry;
      if (counterElements && [...counterElements].includes(target)) {
        entry.isIntersecting ? counterAnimation(target) : null;
      }
    });
  };

  // 	Observer
  const observer = new IntersectionObserver(applyEffect, {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  });

  counterElements.forEach((item) => {
    observer.observe(item);
  });
}

// 	FadeIn Effect
function counterAnimation(counter) {
  const speed = 2000;
  const animate = () => {
    const value = +counter.getAttribute("num");
    const data = +counter.innerText;

    const time = value / speed;
    if (data < value) {
      counter.innerText = Math.ceil(data + time);
      setTimeout(animate, 1);
    } else {
      counter.innerText = value;
    }
  };
  animate();
}
